<template>
  <div>
    <div class="clear" style="padding:0 40px">
      <self-back :pageHeaderList="[{'name':'发票申请单'}]" style="float:left"></self-back>
      <div style="display:inline-block;float:right;margin-top:10px">
        <el-button type='primary' size='mini' @click="printDOM">导出</el-button>
      </div>
    </div>
    <div v-loading='loading' style="background:#fff;padding-bottom:40px">
      <div ref="print" id="ImageExportDom">
        <div>
          <h3 class="title">{{invoice.statements_type==2?'MCN发票申请单':'开具发票申请单'}}<br /><span style="font-size: 14px;line-height: 20px;font-weight: initial;">{{invoice.company}}</span></h3>
          <img src="@/assets/img/voided.png" v-if="voided.length!=0" class="voided" alt="">
          <img src="@/assets/img/underReview.png" style="left: auto;width: 80px;height: 80px;right: 200px;top: 50px;" v-if="voided.length!=0&&(voided.status==1||voided.status==2)" class="voided" alt="">
          <div class="bothSides statementsID" v-if="invoice.id">发票序列号：{{invoice.id}}</div>
          <div class="bothSides statementsID" style="top:55px" v-if="invoice.statements_id">结算单序列号：{{invoice.statements_id}}</div>
          <div style="text-align:right;margin:0 24px 10px" v-if="voided.length!=0">
            <span style="color: #262a4f;font-size: 13px;">发票作废状态：</span>
            <span style="color:#EF7400" v-if="voided.status==1">待商务审核</span>
            <span style="color:#EF7400" v-if="voided.status==2">待财务审核</span>
            <span style="color:#EF7400" v-if="voided.status==3">商务审核驳回</span>
            <span style="color:#00BB5D" v-if="voided.status==4">财务审核通过</span>
            <span style="color:#d51313" v-if="voided.status==5">财务审核驳回</span>
          </div>
          <div style="text-align:right;margin:0 24px 10px" v-else>
            <span style="color:#EF7400" v-if="invoice.status==1">待商务审核</span>
            <span style="color:#EF7400" v-if="invoice.status==2">待财务审核</span>
            <span style="color:#EF7400" v-if="invoice.status==3">商务审核驳回</span>
            <span style="color:#00BB5D" v-if="invoice.status==4">财务审核通过</span>
            <span style="color:#d51313" v-if="invoice.status==5">财务审核驳回</span>
            <span style="color:#fc726d" v-if="invoice.status==6">财务发票撤销</span>
          </div>
          <table border="1" class="tabel" bordercolor="#ebeef4">
            <tr style="background:#F8F8FA">
              <td colspan='2' class="label">客户名称：</td>
              <td colspan='3'>{{invoice.customer_name}}</td>
              <td class="label">申请日期:</td>
              <td>{{invoice.applicant_time}}</td>
              <td class="label">申请人：</td>
              <td>{{invoice.handler}}</td>
            </tr>
            <tr>
              <td class="label">序号</td>
              <td class="label">月份</td>
              <td class="label">实际消耗月份</td>
              <td class="label">项目名称</td>
              <td class="label">开票金额</td>
              <td class="label">发票类型</td>
              <td class="label">发票服务名称</td>
              <td colspan='2' class="label" style="width:30%">发票备注</td>
            </tr>
            <tr v-for="(item,index) in order_list" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.month}}</td>
              <td>{{item.order_original_month}}</td>
              <td>{{item.project_name}}</td>
              <td>{{$formatNum(item.invoice_amount)}}</td>
              <td>{{item.invoice_type == 1 ? '增值税专用发票' : item.invoice_type == 2 ? '增值税普通发票' : ''}}</td>
              <td>{{item.service_type}}</td>
              <td colspan='2'>{{item.invoice_note}}</td>
            </tr>
            <tr>
              <td colspan='4'>金额合计</td>
              <td>{{$formatNum(invoice.invoice_amount)}}</td>
              <td></td>
              <td></td>
              <td colspan='2'></td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">开票信息</td>
              <td colspan='7'></td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">名称：</td>
              <td colspan='7' class="con">{{invoice.title}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">税号：</td>
              <!-- <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.tax_id" size='mini' placeholder="请输入税号"></el-input>
              </td> -->
              <td colspan='7' class="con">{{invoice.tax_id}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">地址/电话：</td>
              <!-- <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.address_tel" size='mini' placeholder="请输入地址/电话"></el-input>
              </td> -->
              <td colspan='7' class="con">{{invoice.address_tel}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">银行/账号：</td>
              <!-- <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.bank_account" size='mini' placeholder="请输入银行/账号"></el-input>
              </td> -->
              <td colspan='7' class="con">{{invoice.bank_account}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">收件人：</td>
              <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.consignee" size='mini' placeholder="请输入收件人"></el-input>
              </td>
              <td colspan='7' class="con" v-else>{{invoice.consignee}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">联系人：</td>
              <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.contacts" size='mini' placeholder="请输入联系人"></el-input>
              </td>
              <td colspan='7' class="con" v-else>{{invoice.contacts}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">联系方式：</td>
              <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.contact_number" size='mini' placeholder="请输入联系方式"></el-input>
              </td>
              <td colspan='7' class="con" v-else>{{invoice.contact_number}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">邮寄地址：</td>
              <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.mail_address" size='mini' placeholder="请输入邮寄地址"></el-input>
              </td>
              <td colspan='7' class="con" v-else>{{invoice.mail_address}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">开票说明：</td>
              <td colspan='7' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.note" size='mini' placeholder="请输入备注"></el-input>
              </td>
              <td colspan='7' class="con" v-else style="max-width:300px">{{invoice.note}}</td>
            </tr>
          </table>
        </div>
        <div v-if="uploadFile.length!=0">
          <div v-for="(item,index) in uploadFile" :key="index">
            <div class="enclosure" @click="lookFile(item)">
              <i class="el-icon-search"></i>
              <span>{{item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件'}}</span>
            </div>
            <div class="enclosure" @click="downLoadFiles(item)">
              <i class="el-icon-download"></i>
              <span>下载附件</span>
            </div>
          </div>
        </div>
        <div class="verify_opinion no-print" v-if="editFlag">
          <add-file @file='(val)=>{uploadFile=val}' :fileOtherList='fileList' :uploadOtherFile='uploadFile'></add-file>
        </div>
        <div class="examine">
          <div v-if="invoice.status&&invoice.status!=1" style="margin:5px 0">
            <div style="margin:5px 0">
              <label>商务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.verify_user}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.verify_at}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核备注：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.verify_note}}</span>
            </div>
          </div>

          <div style="margin:10px 0" v-if="isFinance || (userInfo.role_id == 18 && invoice.pre_audit_status)">
              <div style="margin:5px 0">
                  <label>预审结果：</label>
                  <span style="color:#5E5F6B;font-size:14px;">{{invoice.pre_audit_status==1?'通过': invoice.pre_audit_status == 2 ? '驳回' : ''}}</span>
              </div>
              <div style="margin:5px 0">
                  <label>预审意见：</label>
                  <span style="color:#5E5F6B;font-size:14px;">{{invoice.pre_audit_content}}</span>
              </div>
          </div>

          <div v-if="invoice.status==4||invoice.status==5" style="margin:5px 0">
            <div style="margin:5px 0">
              <label>财务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.confirm_verify_user}}</span>
            </div>
            <div style="margin:5px 0">
              <label>财务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.confirm_verify_at}}</span>
            </div>
            <div style="margin:5px 0">
              <label>财务审核备注：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.confirm_verify_note}}</span>
            </div>
          </div>
          <div style="margin:5px 0" v-if="invoice.status==6">
            <label style="color:#fc726d;">财务发票撤销理由：</label>
            <span style="color:#fc726d;font-size:14px;">{{invoice.cancel_note}}</span>
          </div>
          <div style="margin:5px 0;display: flex;" class="no-print" v-if="(userInfo.role_id == 15 && invoice.status == 1) || (isFinance && invoice.status == 2)">
            <label>审核备注：</label>
            <el-input class="textarea" type="textarea" placeholder="请输入审核原因" v-model="reason">
            </el-input>
          </div>
          <!-- S 财务预审-->
          <div style="border-top: 1px solid #eee;" v-if="(userInfo.role_id == 18 && invoice.status == 2 && !invoice.pre_audit_status)">
            <div style="margin-top:20px">
              <label>预审：</label>
              <el-radio-group v-model="preAudit.status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-top:10px">
                <label style="vertical-align: top;">预审备注：</label>
                <el-input class="textarea" type="textarea" maxlength="300" placeholder="请输入审核原因" v-model="preAudit.content"> </el-input>
            </div>
          </div>
          <!-- E 财务预审 -->
        </div>
      </div>
      <div slot="footer" style="text-align: center;margin-top:40px" v-if="editFlag">
        <el-button type="primary" size='small' @click="editInvoice">提 交</el-button>
      </div>
      <div slot="footer" style="text-align: center;margin-top:40px" v-else>
        <!-- S 财务预审 -->
        <template v-if="(userInfo.role_id == 18 && invoice.status == 2 && !invoice.pre_audit_status)">
          <el-button type="primary" size='small' @click="preAuditSubmit">提交</el-button>
        </template>
        <!-- E 财务预审 -->

        <!-- 商务审核 -->
        <div v-if="userInfo.role_id == 15" style="display:inline-block">
          <el-button type="primary" size='small' @click="editStatement(2)" v-if="invoice.status==1">审核通过</el-button>
          <el-button type="primary" size='small' @click="editStatement(3)" v-if="invoice.status==1" style="background:#d51313;border-color:#d51313">审核不通过</el-button>
        </div>

        <!-- 财务10 || 财务17(合一科技公司) || 21(新财务) -->
        <div v-if="isFinance" style="display:inline-block">
          <el-button type="primary" size='small' @click="editStatement(4)" v-if="invoice.status==2">审核通过</el-button>
          <el-button type="primary" size='small' @click="editStatement(5)" v-if="invoice.status==2" style="background:#d51313;border-color:#d51313">审核不通过</el-button>
        </div>
      </div>
      <!-- 查看文件  -->
      <!-- <look-file v-if="lookFlag" :fileUrl='fileUrl' @close="()=>{lookFlag=false}"></look-file> -->
      <!-- 作废信息 -->
      <voided-box :voided='voided' :invoice_status='invoice.status' @uploadInvoiceDetail='getInvoice()'></voided-box>
    </div>
  </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
// import lookFile from '@/components/assembly/lookFile'
import voidedBox from './voided.vue'
export default {
  components: {
    voidedBox,
    // lookFile,
    addFile
  },
  data () {
    return {
      loading: false,
      order_list: [],
      invoice: {},
      routeName: '',
      fileType: '',
      csvTh: [],
      csvData: [],
      lookFlag: false,
      file_url: '',
      userInfo: {},
      fileList: [],
      uploadFile: [],
      reason: '',
      voided: '',
      fileUrl: '',
      editFlag: false,
      preAudit: {//财务预审
        status: '',
        content: ''
      },

    }
  },
  computed: {
    isFinance() { // 当前角色是否为财务 role_id 财务10 || 财务17(合一科技公司) || 新财务21)
      return [10, 17, 21].includes(Number(this.userInfo.role_id))
    },
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.id = this.$route.params.invoice_id;
    this.routeName = this.$route.name
    this.getInvoice()
  },
  methods: {
    /**提交预审 */
    preAuditSubmit(){
      if (this.preAudit.status == '' || !this.preAudit.status) {
        this.$message.warning('请选择预审结果')
        return
      }
      if (this.preAudit.status == 2 && (this.preAudit.content == '' || !this.preAudit.content)) {
        this.$message.warning('请输入审核意见')
        return
      }
      this.$loading(this.$loadingConfig);
      this.$axios.post(this.URL.BASEURL + this.URL.preAuditRecordSave,{
          type: 3,
          data_id_list: [ this.invoice.id ],
          status: this.preAudit.status,
          content: this.preAudit.content,
      }).then((res) => {
          var res=res.data;
          this.$loading(this.$loadingConfig).close();
          if(res&& res.errno == 0){
            if (this.$route.name == '/invoiceExamine') {
              this.$router.push({ path: '/invoiceExamine' })
            } else {
              this.$router.push({ path: '/myInvoiceApply' })
            }
          }else {
            this.$message({
                message: res.err,
                type: 'warning'
            })
          }
      }).catch(()=>{
        this.$loading(this.$loadingConfig).close();
      })
    },
    editStatement (status) {//提交
      if ((status == 3 || status == 5) && (!this.reason || this.reason == '')) {
        this.$message({
          message: '请输入审核原因',
          type: 'warning'
        })
        return
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.verifyInvoice, {
        id: this.id,
        status: status,
        verify_note: this.reason
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          if (this.$route.name == '/invoiceExamine') {
            this.$router.push({ path: '/invoiceExamine' })
          } else {
            this.$router.push({ path: '/myInvoiceApply' })
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getInvoice () {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.invoiceDetail, {
        params: {
          id: this.id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.order_list = res.rst.order_list;
          this.invoice = res.rst.invoice;
          this.voided = res.rst.voided
          if (this.userInfo.role_id == 15) {
            this.reason = this.invoice.verify_note;
          }
          if (this.isFinance) {
            this.reason = this.invoice.confirm_verify_note
          }
          this.uploadFile = this.invoice.files ? this.invoice.files : []
          this.fileList = [];
          if (this.invoice.files) {
            this.invoice.files.forEach((item, index) => {
              this.fileList.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }
          if ((this.invoice.status == 5 || this.invoice.status == 3 || this.invoice.status == 6) && this.routeName != '/invoiceExamine') {
            this.editFlag = true
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    editInvoice () {//发票编辑
      if (!this.uploadFile || this.uploadFile.length == 0) {
        this.$message({
          message: '请提交附件',
          type: 'warning'
        })
        return
      }
      var axios_api = this.URL.BASEURL + this.URL.editInvoice;
      if (this.invoice.status == 6 || this.invoice.status == 3 || this.invoice.status == 5) {//财务发票撤销
        axios_api = this.URL.BASEURL + this.URL.editInvoiceNew;
      }
      this.loading = true;
      this.$axios.post(axios_api, {
        id: this.id,
        tax_id: this.invoice.tax_id,
        address_tel: this.invoice.address_tel,
        bank_account: this.invoice.bank_account,
        consignee: this.invoice.consignee,
        contacts: this.invoice.contacts,
        contact_number: this.invoice.contact_number,
        mail_address: this.invoice.mail_address,
        note: this.invoice.note,
        files: this.uploadFile,
        service_type: this.invoice.service_type
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.$router.replace({ path: '/myInvoiceApply' })
        } else {
          this.loading = false;
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    printDOM () {
      this.getPdf({ title: this.invoice.statements_type == 2 ? 'MCN发票申请单' : '开具发票申请单', noScrollBar: false, invoice: true })
      // document.title = '新媒体事业部消耗表系统'
      // this.$print(this.$refs.print)
    },
    lookFile (data) {//查看文件
      this.fileUrl = data;
      // this.lookFlag = true
      let routeData = this.$router.resolve({
        path: '/lookFile?url=' + this.fileUrl,
      })
      this.$winopen(routeData.href)
    },
    downLoadFiles (data) {//下载
      var url = data.replace("http://", window.location.protocol + '//');
      var doc_name = (url.split('/'))[url.split('/').length - 1]
      this.ajax(url, (xhr) => {
        this.downloadFile(xhr.response, doc_name)
      }, {
        responseType: 'blob'
      })
    },
    downloadFile (content, filename) {
      var a = document.createElement('a')
      var blob = new Blob([content])
      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    ajax (url, callback, options) {
      window.URL = window.URL || window.webkitURL
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      if (options.responseType) {
        xhr.responseType = options.responseType
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(xhr)
        }
      }
      xhr.send()
    },
  }
}
</script>
<style lang="scss" scoped>
@import "./invoiceDetail.scss";
.voided {
  position: absolute;
  right: 300px;
  top: 45px;
  width: 113px;
  height: 82px;
}
</style>
<style lang="scss">
#PrintingBox {
  .el-table--scrollable-y .el-table__body-wrapper {
    height: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newBilling/invoice/invoiceDetail.vue